module.exports = {
    apiHost: 'carrottodo.net',
    apiProtocol: 'http://',
    apiPort: '4000',
    apiServer: 'http://carrottodo.net:4000',
};